import React from "react";

const Feature = () => {
  return (
    <div
      className="flex lg:gap-20 lg:h-[396px]  gap-7 justify-center items-center lg:mt-16 lg:flex-row flex-col lg:px-20 px-4
    "
    >
      <div className="lg:w-[478px] w-[361px] lg:h-[396px] h-[272px] flex justify-center items-center">
        <img src="/Images/assets/Rider.svg" alt="" width={478} height={396} />
      </div>
      <div className="lg:w-[590px] w-[361px] flex flex-col gap-6">
        <h3 className="hidden lg:block lg:text-4xl text-[28px] font-semibold leading-[150%] text-[#364763]">
          Riders First Approach! <br /> Empowering Delivery Partners
        </h3>
        <ul className="lg:w-[590px] w-[361px] flex flex-wrap text-[#606C80] text-base font-medium leading-[150%] lg:gap-3 gap-1  ">
          <li className="flex lg:w-[284px] w-[178px] rounded-3xl p-6 flex-col gap-3 border border-[#131D2D] border-opacity-10">
            <span className="text-[#E5204B] font-semibold">
              Keep 100% of Earnings
            </span>{" "}
            <p className="font-medium text-sm leading-[150%] ">
              No commissions, no cuts—your hard-earned money stays with you.
            </p>
          </li>
          <li className="flex lg:w-[284px] w-[178px] rounded-3xl p-6 flex-col gap-3 border border-[#131D2D] border-opacity-10">
            <span className="text-[#E5204B] font-semibold">
              Work on Your Terms
            </span>{" "}
            <p className="font-medium text-sm leading-[150%] ">
              Enjoy flexible hours and complete freedom to choose your schedule.
            </p>
          </li>
          <li className="flex lg:w-[284px] w-[178px] rounded-3xl p-6 flex-col gap-3 border border-[#131D2D] border-opacity-10">
            <span className="text-[#E5204B] font-semibold">
              Get Paid Instantly
            </span>{" "}
            <p className="font-medium text-sm leading-[150%] ">
              Earn after every ride with no waiting for settlements.
            </p>
          </li>
          <li className="flex lg:w-[284px] w-[178px] rounded-3xl p-6 flex-col gap-3 border border-[#131D2D] border-opacity-10">
            <span className="text-[#E5204B] font-semibold">
              Rewards & incentives
            </span>{" "}
            <p className="font-medium text-sm leading-[150%] ">
              Earn rewards with every successful order delivery
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Feature;
